import React, {PureComponent, useEffect, useMemo, useRef, useState} from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import { AgendaShift, AgendaUser, AgendaUserType, GetAgendaUserQuery, GetAgendaUserQueryVariables, ModelSortDirection, ShiftsByUserQuery, ShiftsByUserQueryVariables, UpdateAgendaShiftMutation, UpdateAgendaShiftMutationVariables, UsersByComIdQuery, UsersByComIdQueryVariables } from '../../graphql/API';
import { getAgendaUser, shiftsByUser, usersByComId } from './queries';
import { useLazyQuery, useQuery } from '@apollo/client';
import { Spinner, Stack } from 'react-bootstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { Pagination } from '@aws-amplify/ui-react';
import Sidebar from '../services/Sidebar/Sidebar';
import { useNotification } from '../../contexts/NotificationProvider';
import useNotificationStorageService from '../services/NotificationStorageService';
import SubscriptionShiftWrapper from './subscriptionWrappers/subscriptionShiftWrapper';
import useDateService from '../services/DateService';
import { MdNewReleases } from 'react-icons/md';
import { SHIFTS_PER_PAGE } from '../../config';
import { IShift } from '../../Types/models';
import Shift from '../../components/Shift';

const ShiftsByUserView = () => {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  const userId = AuthUserId;
  // I18N
  const { t } = useTranslation();
  const savedLang = Cookies.get('language');
  const [locale, setLocale] = useState("en");
  // PARAMS
  // const { id } = useParams<{ id: string }>();
  // PAGINATION
  const [pageTokens, setPageTokens] = React.useState([null]);
  const [totalPagination, setTotalPagination] = React.useState(1);
  const [currentPageIndex, setCurrentPageIndex] = React.useState(1);
  const [hasMorePages, setHasMorePages] = React.useState(true);
  const [dontUpdateAnymore, setDontUpdateAnymore] = useState(false);
  const [shiftsState, setShiftsState] = useState([]);
  // NAVIGATION
  const navigate = useNavigate();
  const location = useLocation();
  // DATE SERVICES
  const {getTIMEZONE, getPastDate, getDateNow} = useDateService();
  // HOME SETTINGS
  const TIMEZONE = getTIMEZONE();
  // DATE NOW
  const now = useMemo(() => getDateNow(new Date(), TIMEZONE), []);
  // SHIFTS
  const [newShifts, setNewShifts] = useState<AgendaShift[]>([]);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  // SUBSCRIPTION
  const [subscriptionKey, setSubscriptionKey] = useState(0);
  // NOTIFICATION
  const notificationContext = useNotification();
  const notificationCount = notificationContext?.notificationCount;
  const setNotificationCount = notificationContext?.setNotificationCount;
  const shiftCount = notificationContext?.shiftCount;
  const setShiftCount = notificationContext?.setShiftCount;
  const shiftAcceptedCount = notificationContext?.shiftAcceptedCount;
  const setShiftAcceptedCount = notificationContext?.setShiftAcceptedCount;
  const confirmShiftCount = notificationContext?.confirmShiftCount;
  const setConfirmShiftCount = notificationContext?.setConfirmShiftCount;
  const {updateNotificationModelCount} = useNotificationStorageService(); 
  // LINK
  const setShiftLink = notificationContext?.setShiftLink;
  const setConfirmShiftLink = notificationContext?.setConfirmShiftLink;

  const {data: dataUser, loading: loadingUser, error: errorUser, refetch: refetchUser, fetchMore: fetchMoreUser} = useQuery
    <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser,
      {variables: {userId: AuthUserId}});

  // const [fetchDataShifts, {data: dataShifts, loading: loadingShifts, error: errorShifts, 
  //   refetch: refetchShifts, fetchMore: fetchMoreShifts}] = useLazyQuery
  //   <ShiftsByUserQuery, ShiftsByUserQueryVariables>(shiftsByUser);
  // const {data: dataShifts, loading: loadingShifts, error: errorShifts, 
  //     refetch: refetchShifts, fetchMore: fetchMoreShifts} = useQuery
      // <ShiftsByUserQuery, ShiftsByUserQueryVariables>(shiftsByUser, {variables: {
      //   userId: id,
      //   startAt: { eq: new Date().toISOString() },
      //   // filter: {
      //   //   stopAt: { lt: new Date(new Date().setDate(new Date().getDate() + 1)).toISOString() },
      //   //   confirmed: { eq: true },
      //   //   suspended: { eq: false },
      //   //   deleted: { ne: true },
      //   // },
      //   }});

  // const monday = getMondayOfWeek(new Date());
  // const nextMonday = getNextMonday(new Date());
  // console.log('monday', monday);

  const [fetchShifts, {data, loading, error, refetch, fetchMore}] = useLazyQuery//useQuery
    <ShiftsByUserQuery, ShiftsByUserQueryVariables>(shiftsByUser);

  const [fetchManagers, {data: dataManagers, loading: loadingManagers, error: errorManagers, 
    refetch: refetchManagersData, fetchMore: fetchMoreManagers}] = 
    useLazyQuery<UsersByComIdQuery, UsersByComIdQueryVariables >(usersByComId);

  // console.log(monday);
      
  // const user = dataUser?.getAgendaUser;

  // useEffect(() => {
  //   if (dataShifts && !loadingShifts) {
  //     fetchDataShifts({variables: {
  //       userId: id,
  //       startAt: { eq: new Date().toISOString() },
  //       // filter: { 
  //       //   stopAt: {lt: tomorrow},
  //       //   confirmed: {eq: true},
  //       //   suspended: {eq : false},
  //       //   deleted: {ne: true}}
  //       }});
  //     }
  //     // console.log("USERS ->", users);
  // }, [id]);
  const user = dataUser?.getAgendaUser;
  // const shifts = data?.shiftsByUser?.items;

  useEffect(() => {
    setNotificationCount && setNotificationCount((notificationCount ?? 0) - 
      (shiftCount ?? 0) - (confirmShiftCount ?? 0) - (shiftAcceptedCount ?? 0));
    updateNotificationModelCount('shift', 0);
    updateNotificationModelCount('confirmShift', 0);
    updateNotificationModelCount('shiftAccepted', 0);
    setShiftCount && setShiftCount(0);
    setConfirmShiftCount && setConfirmShiftCount(0);
    setShiftAcceptedCount && setShiftAcceptedCount(0);
    setShiftLink && setShiftLink("");
    setConfirmShiftLink && setConfirmShiftLink("");
  }, [location]);

  useEffect(() => {
    // Vérifier si nous avons navigué ici avec le flag refetchData
    if (location.state && (location.state as any).refetchData) {
      refetch();
    }
  }, [location.state]);
  
  const getShifts = async (token: string) => { //date: Date, 
    if (user?.comId) {
      return await fetchShifts(
        {variables: {
          userId: userId,
          startAt: {gt: getPastDate(1)},
          // sortDirection: ModelSortDirection.DESC, 
          // limit: 10,
          nextToken: token,
          sortDirection: ModelSortDirection.ASC,
          filter: {
              and: [
                  // {stopAt: {lt: getSecondNextMonday(new Date())}},
                  {stopAt: {gt: now}},
              ],
              // stopAt: {lt: getSecondNextMonday(new Date())},
              deleted: {ne: true}, 
              suspended: {eq: false},
              // accepted: {eq: false},
              confirmed: {ne: true},
          }
          // filter: {accepted: {ne: true}, deleted: {ne: true}}//{attributeExists: false}, deleted: {attributeExists: false}} //ne: true ...not working here but in appsync yes
      }});

        // {variables: {
        //   userId: userId, 
        //   startAt: {gt: getPastDate(1).split('T')[0]}, //{gt: monday},//{gt: yesterday},
        //   limit: SHIFTS_PER_PAGE,
        //   nextToken: token,
        //   sortDirection: ModelSortDirection.ASC,
        //   filter: {
        //     and: 
        //       [{stopAt: {lt: getNextMonday(new Date())}}, {stopAt: {gt: now}}],         
        //     deleted: {ne: true}, 
        //     // accepted: {eq: false}, 
        //     confirmed: {ne: true}
        //   }
        //     // stopAt: {lt: nextMonday},//{lt: tomorrow}, 
        //   }
        //   // sortDirection: ModelSortDirection.DESC,
        // // },
      // });
    }
  }
  
  useEffect(() => {
    if (!user) return;
    if (!user?.comId) return;
    if (!user.language) return;
    setLocale(user?.language);
    // if (dataUser && !loading) {
      getShifts(pageTokens[pageTokens.length - 1]);
      // refetch();
      // console.log("USERS ->", users);
    // }
    fetchManagers({variables: {
      comId: user?.comId, 
      sortDirection: ModelSortDirection.DESC, 
      // limit: 10, 
      filter: {
          suspended: {ne: true},
          type: {eq: "MANAGER" as AgendaUserType}
    }}});
  }, [user]);//[dataUser, loading]);

  const managers = dataManagers?.usersByComId?.items || [];

  useEffect(() => {
      if (data && data.shiftsByUser && !dontUpdateAnymore) {

        const newShifts = data.shiftsByUser.items;
        const newToken = data.shiftsByUser.nextToken;
        // console.log('newToken', newToken)
        setShiftsState(newShifts); // Met à jour la liste des utilisateurs
        if (newToken) {
          setPageTokens((prevTokens) => [...prevTokens, newToken]); // Ajoute un nouveau token
          setHasMorePages(true);
        } else {
          setHasMorePages(false); // Pas de token suivant, fin de la pagination
        }
      }
    }, [data]);
  
    useEffect(() => {
      if (hasMorePages) {
        setTotalPagination(pageTokens.length);
      } else {
        setTotalPagination(pageTokens.length - 1);
      }
    },[hasMorePages]);
  
    const handlePageChange = async (pageIndex: any) => {
      setDontUpdateAnymore(true);
      setCurrentPageIndex(pageIndex);
  
      const selectedToken = pageTokens[pageIndex - 1]; // Récupérer le token de la page sélectionnée
      if (selectedToken !== undefined) {
        const { data: { shiftsByUser: { items: newShifts, nextToken: newNextToken } } } = await getShifts(selectedToken);
  
        if (newShifts.length !== 0) {
          setShiftsState(newShifts);
          SHIFTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
          if (newNextToken && !pageTokens.includes(newNextToken)) {
            setPageTokens((prevTokens) => [...prevTokens, newNextToken]);
          }
        } else {
          if (hasMorePages) {
            setHasMorePages(false);
          }
        }
      }
    };
  
    const handleNextPage = async () => {
      setDontUpdateAnymore(true);
        const nextToken = pageTokens[currentPageIndex];
  
        if (nextToken) {
          const { data: { shiftsByUser: { items: newShifts, nextToken: newNextToken } } } = await getShifts(nextToken);
  
          if (newNextToken) {
            setShiftsState(newShifts);
            SHIFTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
            
            if (!pageTokens.includes(newNextToken)) {
                setPageTokens((prevTokens) => [...prevTokens, newNextToken]);
            }
            setCurrentPageIndex(currentPageIndex + 1);
          } else {
            if (newShifts.length > 0) {
              setShiftsState(newShifts);
              SHIFTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
              setCurrentPageIndex(currentPageIndex + 1);
              // removeLastPagination();
              setHasMorePages(false);
            } else {
              if (hasMorePages) {
                // removeLastPagination();
                setHasMorePages(false);
              }
            }
            // setHasMorePages(false); // Si pas de nextToken, on désactive la pagination
          }
          // console.log(pageTokens);
  
          // setCurrentPageIndex(currentPageIndex + 1); // Mise à jour de l'index de la page
        } else {
          console.error("Next token is undefined or null");
        }
    };
  
    const handlePreviousPage = async () => {
      if (currentPageIndex > 1) {
        const prevToken = pageTokens[currentPageIndex - 2];
        const { data: { shiftsByUser: { items: prevShifts, nextToken: newNextToken } } } = await getShifts(prevToken);
  
        setShiftsState(prevShifts);
        // setPageTokens(pageTokens.slice(0, -1)); 
        // if (hasMorePages) {
        //  setHasMorePages(nextToken ? true : false);
        // }
        SHIFTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
        setCurrentPageIndex(currentPageIndex - 1);
      }
  };
  
  const handleSubscriptionError = () => {
    console.warn("Subscription error, retrying in 5s...");
    setTimeout(() => {
      setSubscriptionKey((prev) => prev + 1);
    }, 5000);
  };

  const shifts = shiftsState;
  
  useEffect(() => {
    if (!shifts) return
    if (!shifts[0]) return
    if (!shifts[0].username) {
      document.title = t('title.userShift');
    } else {
      document.title = shifts[0]?.username + t('title.userShift');
    }
  }, [shifts]);

  if (!shifts || !user || !managers) {
    // if (loading || loadingUsers || loadingShift) {
    // if (loading || loadingUsers || loadingShift || !users || !shifts) { // need to keep it like that to load all before the loading stop
    return (
        <div className="spinnerContainer">
            {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
            <Spinner animation="border" role="status" className="spinner">
                <span className="visually-hidden">Loading...</span>
            </Spinner>   
        </div>
    )
  };

  const isNewShift = (shift: AgendaShift) => {
      return newShifts.some(c => c.shiftId == shift.shiftId);
  };

  const mergedPosts = [...newShifts, ...shifts.filter(s => !newShifts.some(n => n.shiftId === s.shiftId))];

  // console.log(shifts);
  return (
    <>
      <div className="d-flex">
        <Sidebar user={user} />
        <div className="users-container flex-grow-1 p-3">
          <div className="users-container">
            <div className="tabs">
                <div className="post_row" style={{width: 260 }}>
                    <div className='linkPostTeammate' style={{width: 260 }}>
                        <MdNewReleases size={30} color="#CCC" />
                        <span className='textTab'>{t('home.shiftReceived')}</span>
                    </div>
                </div>
            </div>
            
            {user?.userId && (
              <SubscriptionShiftWrapper
                  key={subscriptionKey}
                  userId={user.userId}
                  subscriptionKey={subscriptionKey}
                  onNewShift={(shift) => {
                      setNewShifts((prev) => [shift, ...prev]);
                  }}
                  onError={handleSubscriptionError}
              />
            )}

            <Stack direction="vertical" gap={3} className="w-100">
            { mergedPosts.map((shift, index) => {
              return (  
                <Shift 
                    // shift={item}
                    shift={{
                        ...shift,
                        user: (shift as any)?.user || null,
                    } as IShift}
                    locale={locale}
                    includedDetails={true}
                    isNew={isNewShift(shift)}
                    user={user as AgendaUser}
                    nav={"Shift"}
                    managers={managers as AgendaUser[]}
                />
              )
            })}
            </Stack>
            <div className="pagination-container">
              {/* <p>tokenLenght: {pageTokens.length}</p>
              <p>pageIndex: {currentPageIndex}</p>
              <p>hasMorePages: {hasMorePages.toString()}</p>
              <p>currentPageIndex: {currentPageIndex}</p> */}
              <h2 className="paginationTitle">{t('title.shifts')}</h2>
              
              <Pagination
                currentPage={currentPageIndex}
                totalPages={totalPagination}//{hasMorePages ? pageTokens.length: pageTokens.length - 1} //{Math.ceil(pageTokens.length / 10)} // Supposons que chaque page ait 10 éléments
                hasMorePages={hasMorePages}
                onNext={handleNextPage}
                // onPrevious={() => setCurrentPageIndex(currentPageIndex - 1)}
                onPrevious={handlePreviousPage}
                onChange={handlePageChange}
                // onChange={(pageIndex) => setCurrentPageIndex(pageIndex)}
                // showFirstLast
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShiftsByUserView;


